import { atom } from 'recoil';

// The real session is an httpOnly cookie set by the server — JS cannot read it.
// We use the presence of 'userData' in localStorage as the login marker so the UI
// shows the authenticated view on reload. Every API call is validated server-side.
const authAtom = atom({
    key: 'token',
    default: localStorage.getItem('mh_userData') ? 'authenticated' : '',
});

export { authAtom };
